import { CalendlyExpert } from "@/features/experts/types/CalendlyExpert"
import { useCallback, useEffect, useState } from "react"
import { getNutritionistByPatientId } from "../../../utils/apis/medicaluser-service"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useExpertsStore } from "../../../utils/stores/useExpertsStore"

export const useNutritionist = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId

    const { experts, updateExperts } = useExpertsStore()
    const nutritionist = experts.nutritionist

    const [expert, setExpert] = useState<CalendlyExpert | null>(nutritionist)

    const fetchNutritionist = useCallback(async () => {
        if (!idToken || !userId) return

        try {
            const nutri = await getNutritionistByPatientId(idToken, userId)
            if (nutri) {
                console.log(`[NUTRITIONIST]: nutritionist found -> ${nutri.data.name} ${nutri.data.family_name}`)
                setExpert(nutri)
                updateExperts({ nutritionist: nutri })
            } else {
                setExpert(null)
                updateExperts({ nutritionist: null })
            }
        } catch (err) {
            console.error("Error fetching nutritionist:", err)
        }
    }, [idToken, userId, updateExperts])

    useEffect(() => {
        if (!nutritionist) {
            fetchNutritionist()
        } else {
            console.warn("[NUTRITIONIST]: already stored, returning it")
            setExpert(nutritionist)
        }
    }, [nutritionist, fetchNutritionist])

    return { expert, fetchNutritionist }
}